import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Box, Row, Typography } from 'seagull';
import { Clock } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import EditableTableCell from '../../EditableTableCell/EditableTableCell';
import { ClientModalContent } from './ClientModalContent/ClientModalContent';
export const GetClientCellTID = (parentTestId)=>getTestIds(parentTestId);
export function ClientCell(param) {
    let { draft, onOpenModal, getClientName, isDisabled, disabledTooltip, testId } = param;
    const { ClientCellTestIds: TID } = useMemo(()=>GetClientCellTID(testId), [
        testId
    ]);
    const { t: draftCellsTexts } = useLocaleKeys('pages.draftsDashboard.editTable.draftCells');
    const { t: editTableTexts } = useLocaleKeys('pages.draftsDashboard.editTable');
    const clientName = getClientName(draft);
    const isScheduled = draft.scheduledDate() != null;
    const openClientModal = ()=>onOpenModal({
            renderContent: (param)=>{
                let { draft: editedDraft, setDraft } = param;
                return {
                    title: draftCellsTexts.client(),
                    testId: TID.Modal(),
                    onSubmit: (defaultBehavior)=>void defaultBehavior(),
                    content: /*#__PURE__*/ _jsx(ClientModalContent, {
                        draft: editedDraft,
                        setDraft: setDraft
                    })
                };
            }
        });
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: TID.Root(),
        onClick: openClientModal,
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        children: /*#__PURE__*/ _jsxs(Row, {
            gap: 8,
            alignItems: "center",
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    ellipsis: true,
                    weight: "normal",
                    skin: clientName ? 'standard' : 'secondary',
                    testId: TID.Name(),
                    children: clientName || editTableTexts.notSet()
                }),
                isScheduled && /*#__PURE__*/ _jsx(Box, {
                    testId: TID.ScheduledIcon(),
                    children: /*#__PURE__*/ _jsx(Clock, {
                        size: 16
                    })
                })
            ]
        })
    });
}
